import * as tslib_1 from "tslib";
import { BaseComponent } from "./BaseComponent";
var IntrinsicComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IntrinsicComponent, _super);
    function IntrinsicComponent(tagName, options) {
        var _this = _super.call(this, options) || this;
        _this.tagName = tagName;
        return _this;
    }
    IntrinsicComponent.prototype.render = function (childNodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var childNodesContent, options;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(Array.prototype.concat.apply([], childNodes))];
                    case 1:
                        childNodesContent = _a.sent();
                        options = $.extend({}, this.options, { html: childNodesContent });
                        return [2 /*return*/, $("<" + this.tagName + ">", options)];
                }
            });
        });
    };
    return IntrinsicComponent;
}(BaseComponent));
export { IntrinsicComponent };
//# sourceMappingURL=IntrinsicComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/components/IntrinsicComponent.js
// module id = 35
// module chunks = 1